module.exports = __webpack_public_path__ + "static/img/umy_future.f5ed8d93.png";